import settings from './settings'

export const map = {
  rub: '₽',
  usd: '$',
  eur: '€'
}

const currencyInPrefix = ['usd', 'eur']

export function getCurrency (currency) {
  const alias = currency.toLowerCase()
  return alias in map ? map[alias] : currency
}

export function format (amount, currency) {
  const symbol = getCurrency(currency)
  const prefix = currencyInPrefix.indexOf(currency.toLowerCase()) > -1

  const values = (parseFloat(amount).toFixed(2)).split('.')
  const decimal = parseInt(values[0]).toLocaleString(settings.LOCALE)
  const fraction = '.' + values[1]

  if (prefix) {
    return symbol + ' ' + decimal + '<span class="currency">' + fraction + '</span>'
  } else {
    return decimal + '<span class="currency">' + fraction + ' ' + symbol + '</span>'
  }
}
